import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { IconLabelComponent } from '../../../../common/icon-label/icon-label.component';
import { PwaPointsBannerComponent } from '../points-banner/pwa-points-banner.component';

@Component({
    selector: 'pwa-account-back',
    templateUrl: './pwa-account-back.html',
    standalone: true,
    imports: [RouterModule, IconLabelComponent, PwaPointsBannerComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaAccountBackComponent extends UiComponent {
    protected override asyncCd = false;

    @Input()
    link = '/account';

    @Input()
    coins?: number;

    @Input()
    rosettes?: number;

    @Input()
    pointsText?: string;
}
